import get from 'lodash.get';
import { getCountryFeatureConfig } from '../../hooks/use-country-config';

export const selectConfig = (state) => get(state, 'countryConfig');

// TODO: getcountryFeatureConfig returns a new reference every time, it should be memoized
export const selectFeatureConfig = (state, featureName) => {
  const config = get(state, 'countryConfig') || [];
  return getCountryFeatureConfig(config, featureName);
};
